import React from "react";
import * as Dati from "src/Dati";
import { _Autocomplete, _Select } from ".";

interface ISelectFieldProps {
    Info: Dati.CInfoCampo;
    Value: string | number;
    OnChange: (e: string, val: string) => void;
}

export const _SelectField: React.FC<ISelectFieldProps> = ({ Info, Value, OnChange }) => {
    if ((Info.TipoTabella == "" || Info.TipoTabella == null) && Info.TipoJSON != "") {
        return <_Select Value={Value || ""} Name={Info.Campo} Label={Info.Etichetta} OnChange={OnChange} Options={JSON.parse(Info.TipoJSON) || {}} />;
    }

    if (Info.TipoTabella != "" && (Info.TipoJSON == "" || Info.TipoJSON == null)) {
        return <_Autocomplete Value={Value || ""} Name={Info.Campo} Label={Info.Etichetta} OnChange={OnChange} Url={Info.TipoTabella} />;
    }

    return <_Select Value="Error" Name="Error" Label={Info.Etichetta} OnChange={() => {}} Options={{ Error: new Dati.CTipo("Error", "Errore") }} />;
};



// WEBPACK FOOTER //
// ./src/inar2/form/SelectField.tsx